import styled from 'styled-components'

export const Container = styled.div`
  position: sticky;
  top: 10px;
  max-height: 96vh;
  overflow-y: auto;
`
